export type LocalSearchSort = 'most_recent' | 'title_asc' | 'title_desc';

export const LOCAL_SORT_OPTIONS = [
    { actionType: 'most_recent' as LocalSearchSort, label: 'Most Recent' },
    { actionType: 'title_asc' as LocalSearchSort, label: 'Title (a-z)' },
    { actionType: 'title_desc' as LocalSearchSort, label: 'Title (z-a)' },
];
